import React, { useMemo } from 'react';
import Tabs from '@/finsight/ui/common/components/Tabs';
import { useResearchContext } from '@/finsight/application/Research/ResearchContext';
import { useDocumentGroupContext } from '@/finsight/application/Research/DocumentGroupContext';

interface ITabsContainerProps {
  dataTest: string,
  isTile: boolean,
  className?: string,
}

const TabsContainer = (props: ITabsContainerProps) => {
  const { documentGroupChanged } = useResearchContext();
  const {
    collection: tabsCollection,
    emptyGroupIds,
    documentGroup: activeTab,
  } = useDocumentGroupContext();

  const tabs = useMemo(() => tabsCollection.map((tab) => ({
    name: tab.groupName,
    key: tab.groupId || '',
    isDisabled: emptyGroupIds.includes(tab.groupId),
  })), [tabsCollection, emptyGroupIds]);

  const onChange = (v) => documentGroupChanged(v, props.isTile);

  return <Tabs tabs={ tabs } onSelect={ onChange } activeTab={ activeTab?.groupId || '' } { ...props } />;
};

export default TabsContainer;
